<template>
<div 
  class="box hoverable plan" 
  @click="selectPlan(plan)"
  :class="{
    'selected-plan': activePlan && activePlan.id === plan.id
  }">
  <columns>
    <column>
      <h4 class="title is-5">{{ plan.title }}</h4>
      <p>{{ plan.intro }}</p>
      <p>{{ plan.description }}</p>
    </column>
    <column class="is-narrow has-text-right">
      <p v-if="planPriceLessDiscount > 0">
        {{ planPriceLessDiscount | asCurrency('USD $') }} p/m
        <br>
        <small>Billed {{ annual ? 'Annually' : 'Monthly' }}</small>
      </p>
      <p v-else>Free</p>
    </column>
  </columns>
</div>  
</template>
<script>
export default {
  
  props: {
    plan: {
      type: Object,
      default: () => ({})
    },
    annual: {
      type: Boolean
    },
    activePlan: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    selectPlan(plan) {
      this.$emit('selected', plan)
    }
  },

  computed: {
    planPriceLessDiscount() {
      if(this.annual) {
        return this.plan.price - (.2 * this.plan.price)
      }
      return this.plan.price
    }
  }

}
</script>